import {
  IconBriefcase,
  IconCertificate,
  IconScubaMask,
  IconUser,
} from '@tabler/icons-react';
import AccountManagementCard from './components/AccountManagementCard';
import ProfileReadinessBanner from './components/ProfileReadinessBanner';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import useMyProfile from '../../hooks/useMyProfile';

const Profile = () => {
  const navigate = useNavigate();
  const {
    completenessData,
    readinessPercent,
    missingFields,
    nextSection,
    isLoading,
  } = useMyProfile(true);

  if (isLoading) {
    return (
      <div className="p-6 flex flex-col items-center justify-center">
        <div className="w-full min-w-80 md:max-w-[1140px]">
          <Skeleton
            variant="text"
            width={280}
            height={42}
            style={{ marginBottom: 16 }}
          />
          <div className="mt-4 flex flex-col md:flex-row md:items-center">
            <Skeleton variant="text" width={210} height={28} />
            <Skeleton
              variant="text"
              width={210}
              height={20}
              style={{ marginLeft: 16, marginTop: 4 }}
            />
          </div>
          <Skeleton
            variant="rectangular"
            height={120}
            style={{ marginTop: 24, marginBottom: 8, borderRadius: 16 }}
          />
          <div className="flex flex-wrap justify-center md:justify-start gap-6">
            {[1, 2, 3, 4].map(item => (
              <Skeleton
                key={item}
                variant="rectangular"
                className="w-full md:w-[364px]"
                height={205}
                style={{ marginTop: 24, borderRadius: 16 }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="p-6 flex flex-col items-center justify-center">
        <div className="w-full min-w-80 md:max-w-[1140px]">
          <p className="text-2xl md:text-3xl font-semibold text-neutral-800">
            Profile
          </p>
          <div className="mt-4 flex flex-col md:flex-row md:items-center">
            <span className="text-base font-semibold text-neutral-800">
              Hello, {completenessData.fullName || 'diver'}
            </span>
            <span className="mt-2 md:mt-0 md:ml-2 text-sm font-normal text-neutral-500">
              {completenessData.email}
            </span>
          </div>
          <ProfileReadinessBanner
            readinessPercent={readinessPercent}
            nextSection={nextSection}
            missingCount={missingFields.length}
            onFinish={path => navigate(path)}
          />
          <div className="flex flex-wrap justify-center md:justify-start gap-6">
            <AccountManagementCard
              icon={<IconUser size={24} />}
              title="Basic personal info"
              description="Provide basic personal details"
              handleNavigate={() => navigate('/profile/basic-personal-info')}
              data={completenessData}
              section="basicPersonalInfo"
            />
            <AccountManagementCard
              icon={<IconBriefcase size={24} />}
              title="Travel documents"
              description="Provide your passport information to book your national park entrance"
              handleNavigate={() => navigate('/profile/travel-documents')}
              data={completenessData}
              section="travelDocuments"
            />
            <AccountManagementCard
              icon={<IconCertificate size={24} />}
              title="Dive certificate"
              description="Provide your dive certification level and the certifying organization."
              handleNavigate={() => navigate('/profile/dive-certificate')}
              data={completenessData}
              section="diveCertificate"
            />
            <AccountManagementCard
              icon={<IconScubaMask size={24} />}
              title="Dive equipment"
              description="Optional rental sizes. If you rent gear, we forward these to the liveaboard organizer."
              handleNavigate={() => navigate('/profile/dive-equipment')}
              data={completenessData}
              section="diveEquipment"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
